<p-select
  [options]="languages"
  [(ngModel)]="selectedLanguage"
  optionLabel="name"
  (onChange)="onLanguageChange($event)"
  [style]="{ 'min-width': '120px' }"
  class="language-selector"
  placeholder="Language"
  [showClear]="false"
/>